import { InjectionToken } from '@angular/core';

import { IMessagingEnvironment } from './interfaces/IMessagingEnvironment';

export const MESSAGING_CONFIG = new InjectionToken<IMessagingEnvironment>('messagingEnvironment');
